import Joi from "joi";

export const locationSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  isDefault: Joi.boolean().label("Is Default"),
  companyId: Joi.string()
    .invalid("00000000-0000-0000-0000-000000000000")
    .min(2)
    .required()
    .label("Company"),
});
